import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { getUserMainAccessType } from "../lib/firebase/database";
import Loader from "./Loader";
import Home from "../pages/inicio/page";

const MainRouteRedirect = () => {
    const { user } = useAuth();
    const [status, setStatus] = useState("checking");

    useEffect(() => {
        let cancelled = false;

        const resolveMainRoute = async () => {
            if (!user) {
                if (!cancelled) {
                    setStatus("landing");
                }
                return;
            }

            const accessType = await getUserMainAccessType(user.uid);

            if (cancelled) {
                return;
            }

            if (accessType === "program_access") {
                setStatus("program");
                return;
            }

            if (accessType === "course_access") {
                setStatus("courses");
                return;
            }

            setStatus("landing");
        };

        resolveMainRoute();

        return () => {
            cancelled = true;
        };
    }, [user]);

    if (status === "checking") {
        return <Loader />;
    }

    if (status === "program") {
        return <Navigate to="/formacao" replace />;
    }

    if (status === "courses") {
        return <Navigate to="/cursos" replace />;
    }

    return <Home />;
};

export default MainRouteRedirect;
